export const normalizeFees = (res) => {
    const d = res?.data ?? res ?? {};
    return {
        fxTransferFee: Number(d.fxTransferFee ?? 0),
        transactionFee: Number(d.transactionFee ?? 0),
        flatByCurrency: {
            NGN: Number(d.NGNTransferFee ?? d.localTransferFee ?? 0),
            USD: Number(d.USDTransferFee ?? 0),
            GBP: Number(d.GBPTransferFee ?? 0),
            EUR: Number(d.EURTransferFee ?? 0),
        },
        crossBorderTransferFee: Number(d.crossBorderTransferFee ?? 0),
        minimums: {
            NGN: Number(d.minimumTranferAmountNgn ?? 0),
            FX: Number(d.minimumTranferAmountFx ?? 0),
        },
    };
};
